import { AuthState } from './types';
import { getLoginStepFromStorage } from '../lib/form-step-storage/form-step-storage';
import { getLoginValueFromStorage } from '../lib/login-value-storage/login-value-storage';

export const initialState: AuthState = {
    currentStep: getLoginStepFromStorage(),
    login: getLoginValueFromStorage(),
};
